// export declare type NotifyTypes = 'default' | 'success' | 'danger' | 'warning';

export const NOTIFY_TYPE_DEFAULT = 'default';
export const NOTIFY_TYPE_SUCCESS = 'success';
export const NOTIFY_TYPE_WARNING = 'warning';
export const NOTIFY_TYPE_DANGER = 'danger';

export declare type NotifyType = 'danger' | 'default' | 'success' | 'warning';

// export enum NotifyTypes {
//   default = 0,
//   success = 1,
//   danger = 2,
//   warning = 3
// }

// export class Environment {

// }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/notify/notify-types.ts